import { MembersAreaWidgetPluginService } from './members-area-widget-plugin';
export { createWidgetPluginExports } from './widget-plugin-exports';
export { routerDataServiceFactory } from './route-data';
export function createMembersAreaWidgetPluginService() {
  return new MembersAreaWidgetPluginService();
}
//# sourceMappingURL=index.js.map